export default __webpack_public_path__ + "static/media/group.40777ef2.jpg";